import { ApiFundOfFundsPortfolio } from '../../api'
import {
  ApiBusinessUnit,
  ApiClient,
  ApiCPPIStrategy,
  ApiModelPortfolio,
  ApiNote,
  ApiPassThroughStrategy,
  ApiSelfSelectPortfolio,
  ApiTIPPStrategy,
  ApiTradingAccount,
  ApiVolControlStrategy
} from '../../api/_legacy/generated-api'

export type StrategyType = 'delta1' | 'riskmanaged' | 'leverage' | 'protection'

export type Fee = {
  calculatedOn: string
  frequency: string
  isVatApplicable: boolean
  name: string
  rate: string
}

export enum TradeActivationStep {
  unDef = -1,
  draft = 1,
  rejected = 2,
  expired = 3,
  deleted = 4,
  // The below are ordered and expected to be difference of 1 from each other
  submit = 5,
  setEconomics = 6,
  approve = 7,
  commitment = 8,
  clientCommitment = 9,
  settlement = 10,
  activate = 11,
  active = 12,
  // leaving count for more status
  inactive = 20
}

export type SavedState = {
  account: ApiTradingAccount
  businessUnit: ApiBusinessUnit
  client: ApiClient
  currency: string
  currentAccountValue: number
  currentPortfolio?: ApiModelPortfolio | ApiFundOfFundsPortfolio | ApiSelfSelectPortfolio
  currentStateInvestment: number
  currentStrategy?:
    | ApiPassThroughStrategy
    | ApiCPPIStrategy
    | ApiTIPPStrategy
    | ApiVolControlStrategy
  note: ApiNote
  pendingStateInvestment: number
  status: TradeActivationStep
  tradeDocumentationUrl?: string
}

export type NumberField = {
  max: number
  min: number
  value: number
}

export type DateField = {
  max: string
  min: string
  value: string
}
